export const BROKERS = [
  // Crypto
  "Delta Exchange", "CoinDCX", "Binance",
  // CFD Retail
  "Exness", "XM", "IC Markets", "Pepperstone",
  // Prop Firms
  "FTMO", "Funding Pips", "FundedNext", "The5%ers",
  // Indian Equity
  "Zerodha", "Upstox", "Groww", "Angel One", "ICICI Direct", "HDFC Securities",
];

// Broker classification — drives form/UI behavior (CFD lot sizing, prop firm
// split, etc.). Keep in sync with BROKERS above.
export const BROKER_TYPES = {
  CRYPTO: ["Delta Exchange", "CoinDCX", "Binance"],
  CFD_RETAIL: ["Exness", "XM", "IC Markets", "Pepperstone"],
  PROP_FIRM: ["FTMO", "Funding Pips", "FundedNext", "The5%ers"],
  EQUITY: ["Zerodha", "Upstox", "Groww", "Angel One", "ICICI Direct", "HDFC Securities"],
};

export const getBrokerType = (broker) => {
  for (const [type, brokers] of Object.entries(BROKER_TYPES)) {
    if (brokers.includes(broker)) return type;
  }
  return "EQUITY";
};

export const SYMBOLS = [
  // Crypto Majors
  "BTCUSDT", "ETHUSDT", "SOLUSDT", "BNBUSDT", "XRPUSDT",
  // Delta USD-margined inverse perps (different contract lot sizes — see DELTA_CONTRACT_LOT_SIZES)
  "BTCUSD", "ETHUSD",
  // Extra alt-coin USDT pairs (Delta / CoinDCX / Binance)
  "LTCUSDT", "DOGEUSDT", "AVAXUSDT", "MATICUSDT", "ADAUSDT", "DOTUSDT", "LINKUSDT",
  // Delta Gold (crypto-backed) — must come before XAUUSD so override matches first
  "XAUTUSDT", "PAXGUSDT",
  // CFD Metals
  "XAUUSD", "XAGUSD",
  // CFD Forex Majors
  "EURUSD", "GBPUSD", "USDJPY", "USDCHF", "AUDUSD", "USDCAD", "NZDUSD",
  // CFD Forex Crosses
  "GBPJPY", "EURJPY", "EURGBP", "AUDJPY", "EURAUD", "GBPAUD", "CADJPY", "CHFJPY", "AUDCAD", "NZDJPY", "EURCAD", "GBPCAD",
  // CFD Indices (incl. broker aliases)
  "NAS100", "NASDAQ", "US30", "US500", "SP500", "GER40", "UK100", "JP225",
  // CFD Commodities / Energies
  "USOIL", "OIL", "UKOIL", "NATGAS",
  // Funding Pips crypto (USD-denominated, lot-based)
  "XRPUSD", "SOLUSD", "LTCUSD",
  // Indian Equity
  "NIFTY", "BANKNIFTY", "FINNIFTY", "SENSEX",
  "RELIANCE", "TCS", "INFY", "HDFCBANK", "ICICIBANK", "SBIN", "AXISBANK", "TATASTEEL",
];

// ---------- Broker → Symbol mapping (Iter 22) ----------
// Restricts the symbol dropdown to only those a given broker actually offers.
// When no broker is selected, the full SYMBOLS list is shown.
export const BROKER_SYMBOLS = {
  "Delta Exchange": ["BTCUSDT", "ETHUSDT", "SOLUSDT", "BNBUSDT", "XRPUSDT", "BTCUSD", "ETHUSD", "LTCUSDT", "DOGEUSDT", "AVAXUSDT", "MATICUSDT", "ADAUSDT", "DOTUSDT", "LINKUSDT", "XAUTUSDT", "PAXGUSDT"],
  "CoinDCX":        ["BTCUSDT", "ETHUSDT", "SOLUSDT", "XRPUSDT", "BNBUSDT", "ADAUSDT", "DOGEUSDT", "MATICUSDT", "LTCUSDT"],
  "Binance":        ["BTCUSDT", "ETHUSDT", "BNBUSDT", "SOLUSDT", "XRPUSDT", "DOGEUSDT", "ADAUSDT", "AVAXUSDT", "DOTUSDT", "MATICUSDT", "LINKUSDT", "LTCUSDT"],
  "Zerodha":        ["NIFTY", "BANKNIFTY", "FINNIFTY", "SENSEX", "RELIANCE", "TCS", "INFY", "HDFCBANK", "ICICIBANK", "SBIN", "AXISBANK"],
  "Angel One":      ["NIFTY", "BANKNIFTY", "FINNIFTY", "RELIANCE", "TCS", "INFY", "HDFCBANK", "ICICIBANK", "SBIN"],
  "Upstox":         ["NIFTY", "BANKNIFTY", "FINNIFTY", "SENSEX", "RELIANCE", "TCS", "INFY", "HDFCBANK", "ICICIBANK", "SBIN"],
  "Groww":          ["NIFTY", "BANKNIFTY", "FINNIFTY", "RELIANCE", "TCS", "INFY", "HDFCBANK"],
  "ICICI Direct":   ["NIFTY", "BANKNIFTY", "RELIANCE", "TCS", "INFY", "HDFCBANK", "ICICIBANK", "SBIN"],
  "HDFC Securities":["NIFTY", "BANKNIFTY", "RELIANCE", "TCS", "INFY", "HDFCBANK", "ICICIBANK"],
  "Exness":         ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "USDCHF", "AUDUSD", "NZDUSD", "USDCAD", "GBPJPY", "EURJPY", "NASDAQ", "US30", "SP500"],
  "XM":             ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "AUDUSD", "USDCAD", "NZDUSD", "USDCHF", "GBPJPY", "EURJPY", "NASDAQ", "US30", "SP500"],
  "IC Markets":     ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "AUDUSD", "USDCAD", "NZDUSD", "USDCHF", "GBPJPY", "EURJPY", "NASDAQ", "US30", "BTCUSD", "ETHUSD"],
  "Pepperstone":    ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "AUDUSD", "USDCAD", "NZDUSD", "GBPJPY", "NASDAQ", "US30", "BTCUSD", "ETHUSD"],
  "FTMO":           ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "AUDUSD", "USDCAD", "GBPJPY", "EURJPY", "NASDAQ", "US30", "SP500", "BTCUSD", "ETHUSD"],
  "Funding Pips":   ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "USDCHF", "AUDUSD", "NZDUSD", "USDCAD", "GBPJPY", "EURJPY", "EURGBP", "AUDJPY", "EURAUD", "GBPAUD", "CADJPY", "CHFJPY", "AUDCAD", "NZDJPY", "EURCAD", "GBPCAD", "NASDAQ", "US30", "SP500", "GER40", "UK100", "JP225", "OIL", "UKOIL", "NATGAS", "BTCUSD", "ETHUSD", "XRPUSD", "SOLUSD", "LTCUSD"],
  "FundedNext":     ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "AUDUSD", "USDCAD", "GBPJPY", "EURJPY", "NASDAQ", "US30", "SP500", "BTCUSD", "ETHUSD"],
  "The5%ers":       ["XAUUSD", "XAGUSD", "EURUSD", "GBPUSD", "USDJPY", "AUDUSD", "USDCAD", "GBPJPY", "EURJPY", "NASDAQ", "US30", "BTCUSD", "ETHUSD"],
};

// Returns the curated symbol list for a broker, or SYMBOLS as a sane fallback
// when the broker has no explicit mapping yet.
export const getBrokerSymbols = (broker) => BROKER_SYMBOLS[broker] || SYMBOLS;

// CFD instrument config — contract size (units per 1 lot) used for lot-based
// P&L math. Indices use 1:1 (price in points).
export const CFD_CONTRACT_SIZES = {
  // Metals
  "XAUUSD": 100,      // 100 oz per lot
  "XAGUSD": 5000,     // 5000 oz per lot
  // Forex majors + crosses (all 100k units = 1 standard lot)
  "EURUSD": 100000, "GBPUSD": 100000, "AUDUSD": 100000, "NZDUSD": 100000,
  "USDCAD": 100000, "USDCHF": 100000, "USDJPY": 100000,
  "GBPJPY": 100000, "EURJPY": 100000, "EURGBP": 100000, "AUDJPY": 100000,
  "EURAUD": 100000, "GBPAUD": 100000, "CADJPY": 100000, "CHFJPY": 100000,
  "AUDCAD": 100000, "NZDJPY": 100000, "EURCAD": 100000, "GBPCAD": 100000,
  // Indices (1 lot = 1 unit, price in points)
  "NAS100": 1, "NASDAQ": 1, "US30": 1, "US500": 1, "SP500": 1, "GER40": 1, "UK100": 1, "JP225": 1,
  // Commodities / energies
  "USOIL": 1000, "OIL": 1000, "UKOIL": 1000, "NATGAS": 1000,
  // Funding Pips crypto (lot-based)
  "BTCUSD": 1, "ETHUSD": 1, "XRPUSD": 1, "SOLUSD": 1, "LTCUSD": 1,
};

export const CFD_COMMISSION_PER_LOT = 7.00; // $7 round trip for Raw/Zero accounts
export const CFD_ACCOUNT_TYPES = ["Standard", "Ultra Low", "Raw / Zero"];
export const PROP_FIRM_DEFAULT_SPLIT = 80; // 80% to trader

// ---------- Funding Pips (Prop Firm) ----------
// Funding Pips has its own symbol universe and a category-based commission
// structure (vs FTMO/FundedNext which use a flat $7/lot). Account types are
// "Standard" (auto category-fee) and "Zero" (manual fee — wider spread, the
// trader enters their own commission since it varies by challenge tier).
export const FUNDING_PIPS_SYMBOLS = [
  // Forex Majors
  "EURUSD", "GBPUSD", "USDJPY", "USDCHF", "AUDUSD", "USDCAD", "NZDUSD",
  // Forex Crosses
  "GBPJPY", "EURJPY", "EURGBP", "AUDJPY", "EURAUD", "GBPAUD", "CADJPY",
  "CHFJPY", "AUDCAD", "NZDJPY", "EURCAD", "GBPCAD",
  // Metals
  "XAUUSD", "XAGUSD",
  // Energies
  "USOIL", "UKOIL", "NATGAS",
  // Indices
  "NAS100", "US30", "US500", "GER40", "UK100", "JP225",
  // Crypto (USD-denominated, lot-based on Funding Pips)
  "BTCUSD", "ETHUSD", "XRPUSD", "SOLUSD", "LTCUSD",
];

// Per-symbol category — drives Funding Pips' commission tier.
// FOREX / METALS / ENERGIES → $2 / lot round trip
// INDICES / CRYPTO        → $0 / lot (commission baked into spread)
export const FUNDING_PIPS_SYMBOL_CATEGORY = {
  EURUSD: "FOREX", GBPUSD: "FOREX", USDJPY: "FOREX", USDCHF: "FOREX",
  AUDUSD: "FOREX", USDCAD: "FOREX", NZDUSD: "FOREX",
  GBPJPY: "FOREX", EURJPY: "FOREX", EURGBP: "FOREX", AUDJPY: "FOREX",
  EURAUD: "FOREX", GBPAUD: "FOREX", CADJPY: "FOREX", CHFJPY: "FOREX",
  AUDCAD: "FOREX", NZDJPY: "FOREX", EURCAD: "FOREX", GBPCAD: "FOREX",
  XAUUSD: "METALS", XAGUSD: "METALS",
  USOIL: "ENERGIES", OIL: "ENERGIES", UKOIL: "ENERGIES", NATGAS: "ENERGIES",
  NAS100: "INDICES", NASDAQ: "INDICES", US30: "INDICES", US500: "INDICES",
  SP500: "INDICES", GER40: "INDICES", UK100: "INDICES", JP225: "INDICES",
  BTCUSD: "CRYPTO", ETHUSD: "CRYPTO", XRPUSD: "CRYPTO",
  SOLUSD: "CRYPTO", LTCUSD: "CRYPTO",
};

export const FUNDING_PIPS_FEE_PER_LOT = {
  FOREX: 2.0,
  METALS: 2.0,
  ENERGIES: 2.0,
  INDICES: 0.0,
  CRYPTO: 0.0,
};

export const FUNDING_PIPS_ACCOUNT_TYPES = ["Standard", "Zero"];

export const isFundingPipsBroker = (broker) => broker === "Funding Pips";

export const getFundingPipsFeePerLot = (symbol) => {
  const cat = FUNDING_PIPS_SYMBOL_CATEGORY[symbol];
  if (!cat) return 0;
  return FUNDING_PIPS_FEE_PER_LOT[cat] ?? 0;
};

export const estimateFundingPipsFee = (symbol, lots) => {
  const perLot = getFundingPipsFeePerLot(symbol);
  const n = Number(lots);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(perLot * n * 100) / 100;
};

export const EMOTIONS = [
  "Confident",
  "Neutral",
  "FOMO",
  "Revenge",
  "Greedy",
  "Fearful",
];

// Premium chip metadata for the Add Trade form. Color is the semantic hue —
// used for the selected border + the rgba background tint.
export const EMOTION_CHIPS = [
  { id: "Confident", emoji: "💪", label: "Confident", color: "#00ff88" },
  { id: "Neutral",   emoji: "😐", label: "Neutral",   color: "#94a3b8" },
  { id: "FOMO",      emoji: "😱", label: "FOMO",      color: "#fbbf24" },
  { id: "Revenge",   emoji: "🤬", label: "Revenge",   color: "#ef4444" },
  { id: "Greedy",    emoji: "🤑", label: "Greedy",    color: "#f97316" },
  { id: "Fearful",   emoji: "😨", label: "Fearful",   color: "#60a5fa" },
];

export const SOURCES = [
  "Own Analysis",
  "Signal/Telegram Group",
  "Influencer/Tip",
  "Copy Trade",
];

// Card metadata for the Trade Source picker. Each card has a unique 4px left
// border accent + soft rgba background tint when selected.
export const SOURCE_CARDS = [
  { id: "Own Analysis",          emoji: "🧠", label: "Own Analysis",    desc: "My own research & setup",     color: "#00ff88" },
  { id: "Signal/Telegram Group", emoji: "📡", label: "Telegram Signal", desc: "Signal from a group/channel", color: "#a78bfa" },
  { id: "Influencer/Tip",        emoji: "👤", label: "Influencer Tip",  desc: "YouTube/Twitter/Discord tip", color: "#f59e0b" },
  { id: "Copy Trade",            emoji: "🔄", label: "Copy Trade",      desc: "Copied someone else's trade", color: "#38bdf8" },
];

// Color per trade source (used in tags + bars)
export const SOURCE_COLORS = {
  "Own Analysis": "#00E5A0",          // green — encouraged
  "Signal/Telegram Group": "#FFC107", // amber
  "Influencer/Tip": "#FF8A65",        // orange
  "Copy Trade": "#5cd8ff",            // blue
};

export const SIDES = ["buy", "sell"];

// Delta-specific crypto-backed gold pairs. These get a flat 0.01% maker/taker
// rate AND hide the Maker/Taker dropdown in the form (only one rate to apply).
export const DELTA_GOLD_SYMBOLS = ["XAUTUSDT", "PAXGUSDT"];

// Delta Exchange contract lot sizes (units of base asset per 1 contract).
// Critical for USD-margined inverse perps (BTCUSD, ETHUSD) where 1 contract is
// a tiny slice of the underlying — applying this scales notional + P&L + margin
// to match Delta's own calculator. Symbols NOT in this map default to 1.0
// (i.e. no scaling — preserves existing BTCUSDT / ETHUSDT behavior).
// Iter 108 — All values below were verified against Delta India's public
// `/v2/products` endpoint (`https://api.india.delta.exchange/v2/products`).
// Keep in sync with backend/broker_constants.py → DELTA_CONTRACT_LOT_SIZES.
export const DELTA_CONTRACT_LOT_SIZES = {
  // USD-quoted inverse perps (Delta India)
  "BTCUSD":   0.001,   // verified 2026-02
  "ETHUSD":   0.01,    // verified 2026-02
  "SOLUSD":   1.0,     // verified 2026-02  (was 0.001 — Delta re-listed as linear)
  "PAXGUSD":  0.001,   // verified 2026-02
  "XAUTUSD":  0.001,   // verified 2026-02
  "SKYAIUSD": 10,      // verified 2026-02
  "SIRENUSD": 10,      // verified 2026-02
  "LABUSD":   10,      // verified 2026-02
  "BEATUSD":  10,      // verified 2026-02
  "HUSD":     100,     // verified 2026-02
  "AINUSD":   100,     // verified 2026-02
  // USDT-quoted linear perps (Delta global)
  "BTCUSDT":  0.001,   // verified 2026-02
  "ETHUSDT":  0.01,    // verified 2026-02
  "SOLUSDT":  1,       // verified 2026-02
  "PAXGUSDT": 0.001,   // verified 2026-02
  "DOGEUSDT": 100,     // verified 2026-02
  "XRPUSDT":  1,       // verified 2026-02
};

export const getDeltaLotSize = (symbol) => DELTA_CONTRACT_LOT_SIZES[symbol] ?? 1;

// Iter 65 — `CFD_CONTRACT_SIZES` defined above (line ~83). We just
// reuse it here for `getRealQuantity`. Same table, single source of
// truth — keep in sync with backend/broker_constants.py.
export const CFD_LIKE_BROKERS = new Set([
  "Exness", "XM", "IC Markets", "Pepperstone",
  "FTMO", "Funding Pips", "FundedNext", "The5%ers",
]);
export const getCfdContractSize = (symbol) => CFD_CONTRACT_SIZES[symbol] ?? 100000;

/**
 * **SINGLE SOURCE OF TRUTH** for raw-broker-units → real underlying-
 * asset quantity. Every `price × qty` calculation in the frontend MUST
 * route through this helper so the form preview, dashboard cards, and
 * Trade Doctor results agree on the same number.
 *
 * Dispatch:
 *   - Delta Exchange  → raw × DELTA_CONTRACT_LOT_SIZES[symbol]
 *   - CFD / Prop      → raw × CFD_CONTRACT_SIZES[symbol]
 *   - Everything else → raw  (qty already in shares/units)
 *
 * Mirrors backend/broker_constants.py::get_real_quantity. Invalid
 * inputs return 0 — never throws.
 *
 * @param {string|null|undefined} broker
 * @param {string|null|undefined} symbol
 * @param {number|string|null|undefined} rawSize
 * @returns {number}
 */
export function getRealQuantity(broker, symbol, rawSize) {
  const qty = Number(rawSize);
  if (!Number.isFinite(qty)) return 0;
  if (broker === "Delta Exchange") {
    return qty * (DELTA_CONTRACT_LOT_SIZES[symbol] ?? 1);
  }
  if (CFD_LIKE_BROKERS.has(broker)) {
    return qty * (CFD_CONTRACT_SIZES[symbol] ?? 100000);
  }
  return qty;
}

// ---------- Exit Discipline (iter 18) ----------
// Tagged outcome of how a trade was closed. Drives the per-row badge in the
// Trades list and the Exit Discipline analytics on the Dashboard.
//   - SL_HIT    → Stop loss hit (auto-fills Exit Price from form.stop_loss)
//   - TP_HIT    → Take profit hit (reveals a Target Price input; auto-fills Exit Price)
//   - CUT_EARLY → Manually closed before either SL/TP reached
//   - MANUAL    → Default; user closed manually for any other reason
export const EXIT_TYPES = [
  { value: "SL_HIT",    label: "SL Hit",    emoji: "🔴", short: "SL", color: "#ef4444" },
  { value: "TP_HIT",    label: "TP Hit",    emoji: "🟢", short: "TP", color: "#00ff88" },
  { value: "CUT_EARLY", label: "Cut Early", emoji: "✂️", short: "Cut", color: "#f59e0b" },
  { value: "MANUAL",    label: "Manual",    emoji: "⚪", short: "M",  color: "#6b7280" },
];
export const EXIT_TYPE_BY_VALUE = EXIT_TYPES.reduce((acc, e) => ((acc[e.value] = e), acc), {});

// ---------- Crypto fee engine ----------
// Crypto brokers get auto-computed trading fees with GST. Rates are decimals
// (multipliers) — e.g. 0.0002 = 0.02%. Symbol-specific overrides take priority
// over the broker default (used for Delta's crypto-backed gold pairs which
// have flat 0.01% maker/taker rates). Keep in sync with backend/server.py.
export const CRYPTO_BROKERS = new Set(["Delta Exchange", "CoinDCX", "Binance"]);
export const CRYPTO_FEE_RATES = {
  "Delta Exchange": {
    default: { maker: 0.0002, taker: 0.0005 }, // 0.02% / 0.05%
    overrides: {
      "XAUTUSDT": { maker: 0.0001, taker: 0.0001 }, // Gold: 0.01% both
      "PAXGUSDT": { maker: 0.0001, taker: 0.0001 }, // Gold: 0.01% both
    },
  },
  "CoinDCX": {
    default: { maker: 0.00025, taker: 0.00075 }, // 0.025% / 0.075%
    overrides: {},
  },
  "Binance": {
    default: { maker: 0.0002, taker: 0.0004 }, // 0.02% / 0.04%
    overrides: {},
  },
};
export const GST_RATE = 0.18; // 18% Indian GST on top of the trading fee
export const ORDER_TYPES = ["taker", "maker"];

export function isCryptoBroker(broker) {
  return CRYPTO_BROKERS.has(broker);
}

/**
 * Resolve the effective maker/taker rate (as decimal multiplier) for a given
 * broker + symbol + order type. Returns null if broker isn't a crypto broker.
 * orderType is case-insensitive ("Maker" | "maker" | "Taker" | "taker").
 */
export const getCryptoFeeRate = (broker, symbol, orderType) => {
  const brokerRates = CRYPTO_FEE_RATES[broker];
  if (!brokerRates) return null;
  const rates = brokerRates.overrides[symbol] || brokerRates.default;
  const ot = String(orderType || "").toLowerCase();
  return ot === "maker" ? rates.maker : rates.taker;
};

/**
 * Round-trip trading fee for crypto brokers, GST inclusive.
 * notional = (entry + exit) × qty × deltaLotSize  (Delta only, else × 1)
 * fee = notional × rate × (1 + GST)
 * `rate` is a decimal multiplier (e.g. 0.0005 for 0.05%).
 */
export function estimateCryptoTradingFee(broker, orderType, entry, exit_p, qty, symbol) {
  const rate = getCryptoFeeRate(broker, symbol, orderType);
  if (rate == null) return null;
  const e = Number(entry), x = Number(exit_p), q = Number(qty);
  if ([e, x, q].some((v) => Number.isNaN(v) || v <= 0)) return null;
  // Iter 65 — single-source-of-truth quantity conversion.
  const baseQty = getRealQuantity(broker, symbol, q);
  const notional = (e + x) * baseQty;
  const fee = notional * rate;
  return Math.round(fee * (1 + GST_RATE) * 100) / 100;
}

// ---------- Non-crypto broker fee table (legacy, simple per-broker %) ----------
// Mirrors backend BROKER_FEE_PCT. Used for the "Total Fees/Charges" auto-estimate
// on non-crypto brokers (Zerodha, Angel One, XM, Exness, etc.).
export const BROKER_FEE_RATES = {
  "Zerodha": 0.05,
  "Angel One": 0.05,
  "XM": 0.03,
  "Exness": 0.03,
};
export const DEFAULT_BROKER_FEE_RATE = 0.05;

export function estimateBrokerFees(broker, entry, exit_p, qty) {
  const rate = BROKER_FEE_RATES[broker] ?? DEFAULT_BROKER_FEE_RATE;
  const e = Number(entry), x = Number(exit_p), q = Number(qty);
  if ([e, x, q].some((v) => Number.isNaN(v))) return null;
  const notional = (e + x) * q;
  return Math.round(((notional * rate) / 100) * 100) / 100;
}

export function formatMoney(amount, currency) {
  const num = Number(amount || 0);
  const symbol = currency === "INR" ? "₹" : "$";
  const formatted = Math.abs(num).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${num < 0 ? "-" : ""}${symbol}${formatted}`;
}

// Exact (unrounded) money — used in fee tooltips so the trader can see the
// precise commission Delta deducted, since the table rounds to 2dp and Delta's
// own Fills tab truncates. Shows up to 8 significant fractional digits, trimmed.
export function formatMoneyExact(amount, currency) {
  const num = Number(amount || 0);
  const symbol = currency === "INR" ? "₹" : "$";
  const formatted = Math.abs(num).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  });
  return `${num < 0 ? "-" : ""}${symbol}${formatted}`;
}


// ── Iter 36: Low trade-count guardrail ──
// Below this threshold, statistically-noisy metrics (Profit Factor, per-
// source/broker/symbol breakdowns, Pattern of the Week) render a
// "Building your profile" placeholder instead of the raw number.
// Keep this constant single-sourced — do NOT hardcode 20 elsewhere.
export const MIN_TRADES_FOR_INSIGHT = 20;
